import { render, staticRenderFns } from "./grade-infoOld.vue?vue&type=template&id=52966707&scoped=true&lang=pug"
import script from "./grade-infoOld.vue?vue&type=script&lang=js"
export * from "./grade-infoOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52966707",
  null
  
)

export default component.exports